<template>
  <div>
    <nav-bar></nav-bar>
    <div class="container">
      <div class="section">

        <div class="field buttons is-grouped">
          <div class="button is-primary is-left" @click="$router.back()">
            <span class="icon"><i class="fas fa-arrow-left"></i></span>
            <span class="is-capitalized">Volver</span>
          </div>
          <div class="button is-primary is-left" @click="getChat">
            <span class="icon"><i class="fas fa-sync-alt"></i></span>
            <span class="is-capitalized">Actualizar</span>
          </div>
        </div>
        <br><br>
        <table class="table is-striped is-fullwidth">

          <thead>
          <tr>
            <th class="is-capitalized">Fecha</th>
            <th class="is-capitalized">Intención</th>
            <th class="is-capitalized">Frase</th>
            <th class="is-capitalized">Mensaje</th>
            <th class="table-button-column"></th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="conversation in paginatedConversations" :key="conversation.idMessage">
            <td>{{conversation.date}}</td>
            <td>{{conversation.intent}}</td>
            <td>{{conversation.term}}</td>
            <td>{{conversation.message}}</td>
            <td>
              <div v-if="conversation.bot" class="button is-primary" @click="showIntent(conversation)">
                <span class="icon"><i class="fas fa-eye"></i></span>
              </div>
            </td>
          </tr>
          </tbody>

        </table>
        <nav class="pagination is-centered" role="navigation" aria-label="pagination">
          <a class="pagination-previous" @click="previousPage" :disabled="paginator.current === 0">Anterior</a>
          <a class="pagination-next" @click="nextPage" :disabled="paginator.current >= paginator.total">Siguiente</a>
          <ul class="pagination-list">
            <li v-for="page in paginator.total+1" :key="page">
              <a :class="page-1 === paginator.current ? 'pagination-link is-current' : 'pagination-link'"
              @click="goPage(page-1)">
                {{page}}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      user: this.$route.params.chat,
      conversations: [],
      paginatedConversations: [],
      page: 0,
      paginator: {
        current: 0,
        total: 0,
        limit: 10
      }
    }
  },
  created () {
    this.getChat()
  },
  methods: {
    getChat () {
      this.api.post('/UserConversation', {idUser: this.user}).then(response => {
        this.conversations = response.conversation
        this.paginator.current = 0
        this.paginator.total = Math.floor(this.conversations.length / this.paginator.limit)
        this.paginate()
      })
    },
    paginate () {
      this.paginatedConversations = this.conversations.slice(
        this.paginator.current * this.paginator.limit,
        (this.paginator.current + 1) * this.paginator.limit)
    },
    nextPage () {
      if (this.paginator.current < this.paginator.total) {
        this.paginator.current++
        this.paginate()
      }
    },
    previousPage () {
      if (this.paginator.current > 0) {
        this.paginator.current--
        this.paginate()
      }
    },
    goPage (page) {
      this.paginator.current = page
      this.paginate()
    },
    showIntent (conversation) {
      this.$router.push('/clients/' + conversation.idClient + '/intents/' + conversation.idIntent + '/sentences')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chats/Chat.vue